export default __webpack_public_path__ + "static/Gilroy-Bold-ca49f7658c4eaac78b6d4dd77a751c59.ttf";